'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, memo } from 'react';
import BaseCard from '@/components/BaseCard';
import CardAwards from '@/components/BaseCard/CardAwards';
import { CaseSlideItem } from '@/components/CasesChunkedSlider/types';
import StrapiRichContent from '@/components/StrapiRichContent';
import css from './style.module.scss';
import Tags from './Tags';
interface Props {
  data: CaseSlideItem;
  width?: number;
  className?: string;
  hideDefaultCursor?: boolean;
  withOverlay?: boolean;
  isVisible?: boolean;
}
const CaseSlide: FC<Props> = t0 => {
  const $ = _c(22);
  const {
    data,
    width,
    className,
    hideDefaultCursor: t1,
    withOverlay,
    isVisible
  } = t0;
  const hideDefaultCursor = t1 === undefined ? true : t1;
  const {
    title,
    image,
    videoUrl,
    thumbnailUrl,
    subtitle,
    url,
    tags,
    awards
  } = data;
  const t2 = url || "";
  const t3 = image?.url;
  const t4 = hideDefaultCursor && css.hideDefaultCursor;
  let t5;
  if ($[0] !== className || $[1] !== t4) {
    t5 = clsx(css.caseSlide, className, t4);
    $[0] = className;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== tags) {
    t6 = tags?.length ? <Tags tags={tags} /> : null;
    $[3] = tags;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== awards) {
    t7 = <CardAwards awards={awards} />;
    $[5] = awards;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = isVisible !== false;
  let t9;
  if ($[7] !== title) {
    t9 = title ? <h3 className={css.title}><StrapiRichContent content={title} /></h3> : null;
    $[7] = title;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== subtitle || $[10] !== t2 || $[11] !== t3 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9 || $[17] !== thumbnailUrl || $[18] !== videoUrl || $[19] !== width || $[20] !== withOverlay) {
    t10 = <BaseCard url={t2} width={width} subtitle={subtitle} videoUrl={videoUrl} thumbnailUrl={thumbnailUrl} imageUrl={t3} className={t5} withOverlay={withOverlay} tags={t6} awards={t7} playing={t8} mainText={t9} />;
    $[9] = subtitle;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = thumbnailUrl;
    $[18] = videoUrl;
    $[19] = width;
    $[20] = withOverlay;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
export default memo(CaseSlide);